import * as React from 'react';
import * as Firebase from 'firebase';

interface Props {
  children: (
    user: Firebase.User | null,
    token: string | null
  ) => React.ReactNode;
}

interface State {
  user: Firebase.User | null;
  token: string | null;
}

export default class FirebaseAuthProvider extends React.Component<Props, State> {
  state = {
    user: null,
    token: null
  };

  handleAuthStateChanged = async (user: Firebase.User | null) => {
    console.warn(
      `firebase auth state changed: ${(user && user.uid) || 'signed-out'}`
    );
    this.setState({ user });

    if (user) {
      const token: string = await user.getIdToken();
      console.warn(`firebase token retrieved ${token}`);
      this.setState({ token });
    }
  };

  componentDidMount() {
    Firebase.auth().onAuthStateChanged(this.handleAuthStateChanged);
  }

  render() {
    return this.props.children(this.state.user, this.state.token);
  }
}



// WEBPACK FOOTER //
// ./src/providers/FirebaseAuthProvider.tsx